import React, { useState } from 'react';
import ContactFormModal from './ContactFormModal';
import { useTranslation } from '../i18n/useTranslation';
import { trackContactClick } from '../track';

const Footer = () => {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <footer className="bg-brand-dark-blue text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 max-w-5xl mx-auto">
          <div>
            <h4 className="font-bold text-lg">{t('footer.produkte.title')}</h4>
            <ul className="mt-4 space-y-2 text-gray-300">
              <li><a href="/produkte/angebotserstellung" className="hover:text-white">{t('footer.produkte.angebotserstellung')}</a></li>
              <li><a href="/produkte/umlauf-und-dienstplanung" className="hover:text-white">{t('footer.produkte.umlaufDienstplanung')}</a></li>
              <li><a href="/produkte/disposition" className="hover:text-white">{t('footer.produkte.disposition')}</a></li>
              <li><a href="/produkte/fehlermeldung" className="hover:text-white">{t('footer.produkte.fehlermeldung')}</a></li>
              <li><a href="/produkte/lohnabrechnung" className="hover:text-white">{t('footer.produkte.lohnabrechnung')}</a></li>
              <li className="font-semibold mt-2 bg-gradient-to-r from-blue-400 to-white bg-clip-text text-transparent">{t('footer.produkte.fuerArztpraxen')}</li>
              <li><a href="https://diktieragent.de" target="_blank" rel="noopener" className="font-semibold hover:bg-gradient-to-r hover:from-blue-400 hover:to-white hover:bg-clip-text hover:text-transparent">{t('footer.produkte.diktieragent')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg">{t('footer.anwender.title')}</h4>
            <ul className="mt-4 space-y-2 text-gray-300">
              <li className="font-semibold text-white">{t('footer.anwender.nachAnwendern')}</li>
              <li className="pl-4"><a href="/anwender/verkehrsunternehmen" className="hover:text-white">{t('footer.anwender.verkehrsunternehmen')}</a></li>
              <li className="pl-4"><a href="/anwender/verkehrsverbuende-und-aufgabentraeger" className="hover:text-white">{t('footer.anwender.verkehrsverbuende')}</a></li>
              <li className="font-semibold text-white mt-2">{t('footer.anwender.nachAnwendungsfall')}</li>
              <li className="pl-4"><a href="/anwender/fahrpersonal-binden" className="hover:text-white">{t('footer.anwender.fahrpersonalBinden')}</a></li>
              <li className="pl-4"><a href="/anwender/steigerung-der-fahrgastzufriedenheit" className="hover:text-white">{t('footer.anwender.fahrgastzufriedenheit')}</a></li>
              <li className="pl-4"><a href="/anwender/betriebskosten-senken" className="hover:text-white">{t('footer.anwender.betriebskostenSenken')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg">{t('footer.unternehmen.title')}</h4>
            <ul className="mt-4 space-y-2 text-gray-300">
              <li><a href="/unternehmen/ueber-uns" className="hover:text-white">{t('footer.unternehmen.ueberUns')}</a></li>
              <li><a href="/unternehmen/karriere" className="hover:text-white">{t('footer.unternehmen.career')}</a></li>
              <li><a href="/unternehmen/kontakt" className="hover:text-white">{t('footer.unternehmen.kontakt')}</a></li>
              <li><a href="/unternehmen/veranstaltungen" className="hover:text-white">{t('footer.unternehmen.veranstaltungen')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg">{t('footer.legal.title')}</h4>
            <ul className="mt-4 space-y-2 text-gray-300">
              <li><a href="/impressum" className="hover:text-white">{t('footer.legal.impressum')}</a></li>
              <li><a href="/datenschutz" className="hover:text-white">{t('footer.legal.datenschutz')}</a></li>
              <li><a href="/nutzungsbedingungen" className="hover:text-white">{t('footer.legal.nutzungsbedingungen')}</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 text-center">
          <button
            onClick={() => {
              trackContactClick('footer');
              setIsContactModalOpen(true);
            }}
            className="inline-block gradient-button gradient-button-hover text-white font-bold text-lg rounded-full px-10 py-4 transition-transform transform hover:scale-105"
          >
            {t('footer.ctaButton')}
          </button>
        </div>
      </div>

      {/* Contact Form Modal */}
      <ContactFormModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} />
    </footer>
  );
};

export default Footer;